'use client'

import { ReactNode, createContext, useEffect, useReducer } from 'react'
import initialState from './state'
import reducer from './reducer'
import { UPDATE_APP_STATE } from './actions'
import { createAction, Logger } from '@wolfdanepug/common-react'

export const AppContext = createContext({
	useAppState: () => ({}),
	useSession: () => ({}),
	updateAppState: (payload: any) => {},
	setNavigationVisible: (payload: boolean) => {},
	setLoading: (payload: boolean) => {},
	cancelLoading: () => {}
})

interface AppProviderProps {
	children: ReactNode | ReactNode[]
}

export const AppProvider = ({ children }: AppProviderProps) => {
	const [state, dispatch] = useReducer(reducer, initialState)

	useEffect(() => {
		Logger.log('[AppProvider] state', state)
	}, [state])

	const controller = (type: string, payload: any) => {
		dispatch(createAction(type, payload))
	}

	useEffect(() => {
		state.error && Logger.error('[AppProvider] error', state.error)
	}, [state.error])

	// // Load the initial session
	// useEffect(() => {
	// 	initializeApp()
	// }, [])

	const useAppState = () => {
		return state
	}

	const useSession = () => {
		return state.session
	}

	return (
		<AppContext.Provider
			value={{
				useAppState,
				useSession,
				updateAppState: (payload: any) => controller(UPDATE_APP_STATE, payload),
				setNavigationVisible: (payload: boolean) =>
					controller(UPDATE_APP_STATE, { navigationVisible: payload }),
				setLoading: (payload: boolean) => controller(UPDATE_APP_STATE, { loading: payload }),
				cancelLoading: () => controller(UPDATE_APP_STATE, { loading: false })
			}}
		>
			{children}
		</AppContext.Provider>
	)
}
